import { render } from "./sponsors.vue?vue&type=template&id=0307f074&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=0307f074&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0307f074"

export default script